import PostBannerImg from './PostBannerImg';

export default PostBannerImg;
export * as PostBannerImgTypes from './PostBannerImg.types';
